import { Component, inject } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { DataService } from 'src/app/data.service';

@Component({
    standalone: false,
    selector: 'bp-aufnahme',
    templateUrl: './aufnahme.component.html',
    styleUrls: ['./hl-area.component.css'],

})
export class AufnahmeComponent extends HlAreaComponent {
  ds: DataService = inject(DataService);

  onNummerChanged(data: { previous: string, current: string }) {
    this.ds.nummerChanged.emit({ id: this.data._id, num: data.current });
  }

  projekteString(): string {
    const projects = this.data.header.projects;
    if (!projects || projects.length === 0) return 'Kein Projekt zugeordnet';
    return projects.map((p: { name: string }) => p.name).join(', ');
  }

  /** Extrahiert die 2-stellige Nummer am Anfang eines Forstamt/Revier-Strings (z.B. "06 Neustrelitz" → "06") */
  private extractNr(value: string | undefined): string {
    if (!value) return '';
    const match = value.match(/^(\d{2})\s/);
    return match ? match[1] : '';
  }

  canGenerateNummer(): boolean {
    return !!this.extractNr(this.data.header.forstamt) && !!this.extractNr(this.data.header.revier);
  }

  /** Erzeugt Bohrpunktnummer: FA-FR-lfdNr-Jahr */
  generateNummer() {
    const fa = this.extractNr(this.data.header.forstamt);
    const fr = this.extractNr(this.data.header.revier);
    if (!fa || !fr) return;

    // Bestehende Nummer original übernehmen (auch Buchstaben)
    const lfdNr = this.data.header.nummer?.trim() || '1';
    const jahr = new Date().getFullYear();
    const newNummer = `${fa}-${fr}-${lfdNr}-${jahr}`;
    this.data.header.nummer = newNummer;
    this.onNummerChanged({ previous: '', current: newNummer });
  }
}
